import React from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable';
import StandardRuleRow from "./standard-rule-row";

export default function StandardRuleRows({ ruleset, rules, handleUpdate, handleShowDeleteModal }) {
  const ruleRows = rules.map((rule, index) => (
    <StandardRuleRow
      ruleset={ruleset}
      rule={rule}
      index={index}
      key={`rule-row-${index}`}
      handleUpdate={handleUpdate}
      handleShowDeleteModal={handleShowDeleteModal}
    />
  ));

  return (
    <SortableContext items={ruleRows} strategy={verticalListSortingStrategy}>
      <tbody className="divide-y divide-gray-200 bg-white">
        { ruleRows }
      </tbody>
    </SortableContext>
  )
}
